<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center pd-20px">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">{{ $t('modifierDates.title') }}</h1>
        </div>
      </div>
      <error-msg-component :messages="messagesPopup"
                           :error="isError"
                           :title="'modifierDates.error.title'"
                           :withEmplyFields="true"
                           @close="isError = $event"
                           class="has-text-left"/>
      <information-msg-component
          v-if="messagesInformation.length > 0"
          :libelleList="messagesInformation"
          title="modifierDates.info.title"
          class="has-text-left"/>
    </div>
    <div class="card-content columns is-multiline">
        <p class="column is-6 has-text-default is-size-6 has-text-weight-bold">
          {{$t('modifierDates.dateDebut')}}
        </p>
        <p class="column is-6 has-text-default is-size-6 has-text-weight-bold">
          {{$t('modifierDates.dateFin')}}
        </p>
        <b-datepicker
          class="column"
          icon="calendar-today"
          show-week-number editable
          nearby-selectable-month-days
          v-model="dateDebut"
          :disabled="disabled">
        </b-datepicker>
        <b-datepicker
          class="column"
          icon="calendar-today"
          show-week-number editable
          nearby-selectable-month-days
          v-model="dateFin">
        </b-datepicker>
    </div>
    <div class="card-content has-text-centered">
          <button class="button btn-modal-annuler is-cancel pdh-20px" @click="$parent.close">
            {{ $t('modifierDates.cancel') }}
          </button>
          <button class="button is-addOrEdit mgl-10px" @click="sendEvent()" :disabled="cantApply">
            {{ $t('modifierDates.apply') }}
          </button>
        </div>
  </div>
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';
import informationMsgComponent from '@/components/general/informationMsgComponent';
import {
  CATEGORIE_UNITAIRE,
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_ECRAN_NUMERIQUE,
} from '@/configuration/catalogue/produitConf';

export default {
  props: {
    lignes: {
      type: Array,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
    informationMsgComponent,
  },
  data() {
    return {
      isError: false,
      messagesPopup: [],
      dateDebut: null,
      dateFin: null,
      messagesInformation: [],
      cantApply: false,
      disabled: false,
    };
  },
  computed: {
    minDateFin() {
      let minDateFin = this.lignesValides[0].dateFin;
      this.lignesValides.forEach((ligne) => {
        if (ligne.dateFin < minDateFin) {
          minDateFin = ligne.dateFin;
        }
      });
      return minDateFin;
    },
    maxDateDebut() {
      let maxDateDebut = this.lignesValides[0].dateDebut;
      this.lignesValides.forEach((ligne) => {
        if (ligne.dateDebut > maxDateDebut) {
          maxDateDebut = ligne.dateDebut;
        }
      });
      return maxDateDebut;
    },
    lignesValides() {
      return this.lignes.filter((ligne) => this.canUpdateDate(ligne));
    },
  },
  methods: {
    sendEvent() {
      this.messagesPopup = [];
      let dateDebutTest = this.dateDebut;
      let dateFinTest = this.dateFin;
      if (!this.dateDebut) {
        dateDebutTest = this.maxDateDebut;
      }
      if (!this.dateFin) {
        dateFinTest = this.minDateFin;
      }
      if (!this.dateDebut && !this.dateFin) {
        this.isError = true;
        this.messagesPopup.push({
          message: 'modifierDates.error.aucuneValeur',
        });
        return;
      }
      if (dateDebutTest >= dateFinTest) {
        this.isError = true;
        this.messagesPopup.push({
          message: 'modifierDates.error.dateDebutSuperieure',
        });
        return;
      }
      const date = {
        dateDebut: this.dateDebut,
        dateFin: this.dateFin,
      };
      this.$emit('updateDate', date);
      this.$parent.close();
    },
    canUpdateDate(ligne) {
      return ligne.typeProduit.toLowerCase() === CATEGORIE_UNITAIRE.toLowerCase()
          || ligne.typeProduit.toLowerCase() === CATEGORIE_REGROUPEMENT_LC.toLowerCase()
          || ligne.typeProduit.toLowerCase() === CATEGORIE_ECRAN_NUMERIQUE.toLowerCase()
          || ligne.typeProduit.toLowerCase() === CATEGORIE_REGROUPEMENT_NUMERIQUE.toLowerCase();
    },
    addInfoMessage(lignes, message) {
      let msg = message;
      if (lignes.length > 1) {
        // nomenclature des nom au pluriel messagePluriel
        msg += 'Pluriel';
      }
      this.messagesInformation.push({
        libelle: this.$t(msg),
      });
      lignes.forEach((ligne) => {
        this.messagesInformation.push({
          libelle: ligne.libelle,
        });
      });
    },
  },
  mounted() {
    if (this.lignesValides.length === 0) {
      this.isError = true;
      this.cantApply = true;
      this.messagesPopup.push({ message: 'modifierDates.error.aucuneLigneValide' });
    }
    if (!this.isError) {
      const lignesNonValides = this.lignes
        .filter((ligne) => !this.lignesValides.find((ligneValide) => ligne === ligneValide));
      const lignesDisabled = this.lignesValides.filter((ligne) => ligne.isAffecteLogistiquement);
      if (lignesNonValides.length > 0) this.addInfoMessage(lignesNonValides, 'modifierDates.info.reseauNonValide');
      if (lignesDisabled.length > 0) {
        this.disabled = true;
        this.addInfoMessage(lignesDisabled, 'modifierDates.info.dateDebutBloquee');
      }
    }
  },
};
</script>
